import React, { useState, useEffect, useContext, useMemo } from "react";
import { Routes, BrowserRouter, Route, Navigate } from 'react-router-dom'
import { AuthContext } from "./hooks/use-auth"

import 'leaflet/dist/leaflet.css';
import Grid from '@mui/material/Grid2';
import { Stack, Box, SwipeableDrawer, Drawer, IconButton } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { FONT_COLOR, BG_COLOR } from "./const/general";
import { RISK_LEGEND_ITEMS, getLegendItem, SOIL_RAIN_LEGEND_ITEMS, TYPHOON_LEGEND_ITEMS } from "./const/legend";
import { RISK_ANALYSIS_LAYER_LIST } from './const/map_config'

import './App.css';
import PrivateRoute from './PrivateRoute';
// components
import Header from './item/header';
import SelectMenus from './item/select_menus'
import SelectMenusPrefShinkoCitys from './components/select_menus_pref_shinko_city'
import IndeterminateRadio from './components/check_radio'
import Logout from './page/logout'
import PageLegend from './item/page_legend'
import Reset from './item/reset'
import SwitchAnnounce from './item/switch_announce'
import Switch6h15h from './item/switch_6h_15h'
import {
  BoxFlexEndTop
} from './style/box'

import Summary from './page/summary'
import SummaryForCity from './page/summary_for_city'
import RiskAnalysis from './page/risk_analysis'
import Typhoon from './page/typhoon'
import SoilRain from './page/soil_rain'
import AreaRisk from './page/area_risk'
import River from './page/river'
import SeniorRisk from './page/senior_risk'
import RoadRisk from './page/road_risk'
import RailwayRisk from './page/railway_risk'
import Isolation from './page/isolation'
import Chronology from './page/chronology'
import SignIn from './page/signin_page'
import Compatibility from './page/compatibility_shizuoka'
import UserRegisterForm from './page/user_register_form'
import Button from '@mui/material/Button';
import { DEFAULT_POSITION } from './config/config'
import { PAGE_NAME } from './const/user_config'
import Risk from "./page/risk";
import ShelterAnalysis from './page/shelter_analysis'


const BasePages = (route, leftMenu, leftLegend, leftReset, SwitchAnnounce, Switch6h15h, tabList, chooseUrl) => {
  const showLeftLegend = !chooseUrl?.includes('river');
  return (
    <>
      <Box sx={{
        width: '100%',
        flexGrow: 1
      }}>
        <Header chooseUrl={chooseUrl} tabList={tabList} leftReset={leftReset} leftMenu={leftMenu} leftLegend={leftLegend} />
        <Grid
          container
          columns={10}
          height={"100%"}
        >
          <Grid size={{ xs: 10, md: 1 }}
            sx={{
              display: { xs: 'none', md: 'flex' },
            }}
          >
            <Box sx={{
              height: 'calc(100dvh - 35px)',
              width: '100%',
              // borderRight: '1px solid #aaaaaa',
              boxSizing: 'border-box',
              p: 1,
              display: 'flex',
              flexDirection: 'column',
            }}>
              <Box sx={{ mt: 1 }}>
                {leftReset}
              </Box>
              <Box>
                {SwitchAnnounce}
              </Box>
              <Box>
                {Switch6h15h}
              </Box>
              <Box sx={{
                flexGrow: 1,
                minHeight: 0,
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                // border: '1px solid white',
              }}>
                {leftMenu}
              </Box>
              {showLeftLegend &&
                <Box sx={{ mt: 1 }}>
                  {leftLegend}
                </Box>
              }
            </Box>
          </Grid>

          <Grid size={{ xs: 10, md: 9 }}
            sx={{ display: 'flex', flexDirection: 'column' }}
            p={1}>
            {route}
          </Grid>
        </Grid>
      </Box>
    </>
  )
};

function Apps() {
  const [citys, setCitys] = useState([]);
  const [selectCitys, setSelectCitys] = useState([]);
  const [rails, setRails] = useState([]);
  const [selectRails, setSelectRails] = useState([]);

  const [chronologyCategory, setChronologyCategory] = useState([]);
  const [selectChronologyCategory, setSelectChronologyCategory] = useState([]);
  const [shelterStatus, setShelterStatus] = useState([]);
  const [selectShelterStatus, setSelectShelterStatus] = useState([]);

  const [isSearchCompatibilityDrawerOpen, setIsSearchCompatibilityDrawerOpen] = useState(false);
  const [isSearchChronologyDrawerOpen, setIsSearchChronologyDrawerOpen] = useState(false);

  const [radioOption, setRadioOption] = useState('市全体');

  const { availableTabs, defaultCities, defaultUnit, enabledPrefs } = useContext(AuthContext);
  // 県コードをユーザーによって切り分け
  const prefCode = (!enabledPrefs || enabledPrefs === "") ? [] : enabledPrefs.split(',');
  const defaultCityArr = (!defaultCities || defaultCities === "") ? [] : defaultCities.split(',');

  const [riskMapCenter, setRiskMapCenter] = useState(DEFAULT_POSITION);
  const [bsnMapCenter, setBsnMapCenter] = useState(DEFAULT_POSITION);
  const [riskMapZoom, setRiskMapZoom] = useState(7);
  const [bsnMapZoom, setBsnMapZoom] = useState(7);
  const [selectSubCity, setSelectSubCity] = useState([]);
  const [selectArea, setSelectArea] = useState([]);
  const [selectMsh, setSelectMsh] = useState([]);
  const [selectBsn, setSelectBsn] = useState([]);
  const [selectTelCode, setSelectTelCode] = useState([]);
  const [selectShelterCode, setSelectShelterCode] = useState([]);


  const [announceSwitch, setAnnounceSwitch] = useState(false);
  const [h6Switch, setH6Switch] = useState(false);
  const [isReadySummaryCity, setReadySummaryCity] = useState({
    rank_soil: false, bar_line_soil: false, heatmap_soil: false,
    rank_river: false, bar_line_river: false, heatmap_river: false,
  });
  const [isReadyRiver, setReadyRiver] = useState({
    rank_river: false, line_river: false, bar_line_river: false
  });
  const [isReadyRiskAnalysis, setReadyRiskAnalysis] = useState({
    left_rank: false, bar_or_line: false
    // , left_text: false
  });
  const [isReadyTyphoon, setReadyTyphoon] = useState({
    bar_line: false
  });
  const [isReadySoilRain, setReadySoilRain] = useState({
    rank_soil_rain: false, treemap_soil_rain: false, scatter_plot_soil_rain: false,
    rank_soil_rain_prein: false, heatmap_soil_rain: false
  });
  const [isReadySummary, setReadySummary] = useState({
    scatter_rain_h1_dc_tank: false, scatter_rain_h1_dc_tank_city: false, bar_line_soil: false, heatmap_rain_city: false, vertical_bar_chronology: false,
    rank_river: false, rank_road_risk: false
  });
  const [isReadyAreaRisk, setReadyAreaRisk] = useState({
    bar_line_soil: false, rank_soil: false, rank_rain: false
  });

  const [isReadyRisk, setReadyRisk] = useState({
    scatter_rain_h1_dc_tank: false, scatter_rain_h1_h24: false, heatmap_rain_city: false, scatter_rain_h1_dc_tank_city: false
  });

  const [isReadyChronology, setReadyChronology] = useState({
    pie_chronology: false, vertical_bar_chronology: false, bar_chronology: false
  });  
  
  const [isReadyShelterAnalysis, setReadyShelterAnalysis] = useState({
    treemap_shelter_analysis: false, rank_last_reported: false, rank_hdcnt_max: false, rank_hdcnt_lag: false,
    line_trend_evac: false, line_trend_shelter: false, vertical_bar_shelter_analysis: false
  });

  const [riskAnalysisLayer, setRiskAnalysisLayer] = useState(RISK_ANALYSIS_LAYER_LIST[0]);

  const tabList = useMemo(() => {
    return availableTabs ? availableTabs.split(',').map(s => s.trim()) : [];
  }, [availableTabs]);

  useEffect(() => {
    document.documentElement.style.setProperty("--font-color", FONT_COLOR);
    document.documentElement.style.setProperty("--bg-color", BG_COLOR);
  }, []);

  const handleCompatibilityDrawerClose = () => {
    setIsSearchCompatibilityDrawerOpen(false);
  };

  const handleChronologyDrawerClose = () => {
    setIsSearchChronologyDrawerOpen(false);
  };

  const LeftMenuCitys = () => {
    return (
      <SelectMenus
        title='市町村名'
        data={citys}
        selectItems={selectCitys}
        setSelectItems={setSelectCitys} />
    )
  }

  const LeftMenuPrefShinkoCitys = () => {
    return (
      <SelectMenusPrefShinkoCitys
        title='市町村名'
        data={citys}
        selectItems={selectCitys}
        setSelectItems={setSelectCitys}
        selectSubCity={selectSubCity}
        setSelectSubCity={setSelectSubCity}
        selectArea={selectArea}
        setSelectArea={setSelectArea}
        selectMsh={selectMsh}
        setSelectMsh={setSelectMsh}
        selectBsn={selectBsn}
        setSelectBsn={setSelectBsn}
        riskMapZoom={riskMapZoom}
        setRiskMapZoom={setRiskMapZoom}
        riskMapCenter={riskMapCenter}
        setRiskMapCenter={setRiskMapCenter}
        bsnMapZoom={bsnMapZoom}
        setBsnMapZoom={setBsnMapZoom}
        bsnMapCenter={bsnMapCenter}
        setBsnMapCenter={setBsnMapCenter}
        isReadySummaryCity={isReadySummaryCity}
        setReadySummaryCity={setReadySummaryCity}
      />
    )
  }

  const LeftReset = (isReady, setReady) => {
    return (
      <Reset
        selectItems={selectCitys}
        setSelectItems={setSelectCitys}
        selectSubCity={selectSubCity}
        setSelectSubCity={setSelectSubCity}
        selectArea={selectArea}
        setSelectArea={setSelectArea}
        selectMsh={selectMsh}
        setSelectMsh={setSelectMsh}
        selectBsn={selectBsn}
        setSelectBsn={setSelectBsn}
        selectTelCode={selectTelCode}
        setSelectTelCode={setSelectTelCode}
        selectShelterCode={selectShelterCode}
        setSelectShelterCode={setSelectShelterCode}
        setRiskMapZoom={setRiskMapZoom}
        setRiskMapCenter={setRiskMapCenter}
        setBsnMapZoom={setBsnMapZoom}
        setBsnMapCenter={setBsnMapCenter}
        isReady={isReady}
        setReady={setReady}
      />
    )
  }

  const LeftMenuCompatibility = () => {
    return (
      <>
        <IndeterminateRadio
          radioOption={radioOption}
          setRadioOption={setRadioOption} />
        <Drawer
          elevation={0}
          anchor='top'
          open={isSearchCompatibilityDrawerOpen}
          onClose={handleCompatibilityDrawerClose}
          sx={{
            '&.MuiDrawer-root .MuiDrawer-paper': {
              marginTop: '49px',
              borderBottom: '1px solid #aaaaaa',
            },
            '&.MuiDrawer-root .MuiBackdrop-root': {
              backgroundColor: 'transparent',
            },
            display: { xs: 'flex', md: 'none' }
          }}
        >
          <Stack sx={{ backgroundColor: '#F2F2F2', padding: '8px 8px 0 8px' }}>
            <IndeterminateRadio
              radioOption={radioOption}
              setRadioOption={setRadioOption} />
            <BoxFlexEndTop>
              <IconButton onClick={handleCompatibilityDrawerClose}>
                <KeyboardArrowUpIcon />
              </IconButton>
            </BoxFlexEndTop>
          </Stack>
        </Drawer>
      </>
    )
  }

  const LeftMenuChronology = () => {
    return (
      <>
        <Stack spacing={2}>
          <SelectMenus
            title='市町村名'
            data={citys}
            selectItems={selectCitys}
            setSelectItems={setSelectCitys} />
          <SelectMenus
            title='被害種別名'
            data={chronologyCategory}
            selectItems={selectChronologyCategory}
            setSelectItems={setSelectChronologyCategory} />
          <SelectMenus
            title='開設状況'
            data={shelterStatus}
            selectItems={selectShelterStatus}
            setSelectItems={setSelectShelterStatus} />
        </Stack>
        <Drawer
          elevation={0}
          anchor='top'
          open={isSearchChronologyDrawerOpen}
          onClose={handleChronologyDrawerClose}
          sx={{
            '&.MuiDrawer-root .MuiDrawer-paper': {
              marginTop: '49px',
              borderBottom: '1px solid #aaaaaa'
            },
            '&.MuiDrawer-root .MuiBackdrop-root': {
              backgroundColor: 'transparent'
            },
            display: { xs: 'flex', md: 'none' }
          }}
        >
          <Stack sx={{ backgroundColor: '#F2F2F2', }}>
            <Grid container
              spacing={2}
              columns={12}
              height={'100%'}
              sx={{ padding: '8px 8px 0 8px' }}
            >
              <Grid size={12}>
                <SelectMenus
                  title='市町村名'
                  data={citys}
                  selectItems={selectCitys}
                  setSelectItems={setSelectCitys} />
              </Grid>
              <Grid size={12}>
                <SelectMenus
                  title='被害種別名'
                  data={chronologyCategory}
                  selectItems={selectChronologyCategory}
                  setSelectItems={setSelectChronologyCategory} />
              </Grid>
              <Grid size={12}>
                <SelectMenus
                  title='開設状況'
                  data={shelterStatus}
                  selectItems={selectShelterStatus}
                  setSelectItems={setSelectShelterStatus} />
              </Grid>
            </Grid>
            <BoxFlexEndTop>
              <IconButton onClick={handleChronologyDrawerClose}>
                <KeyboardArrowUpIcon />
              </IconButton>
            </BoxFlexEndTop>
          </Stack>
        </Drawer>
      </>
    )
  }

  const LeftMenuRails = () => {
    return (
      <SelectMenus
        title='鉄道路線リスト'
        data={rails}
        selectItems={selectRails}
        setSelectItems={setSelectRails} />
    )
  }

  const LeftLegend = (legendItems) => {
    return (
      <PageLegend
        legendItems={legendItems} />
    )
  }

  const LeftSwitchAnnounce = (isReady, setReady) => {
    return (
      <SwitchAnnounce
        announceSwitch={announceSwitch}
        setAnnounceSwitch={setAnnounceSwitch}
        isReady={isReady}
        setReady={setReady}
      />
    )
  }

  const LeftSwitch6h15h = (isReady, setReady) => {
    return (
      <Switch6h15h
        h6Switch={h6Switch}
        setH6Switch={setH6Switch}
        isReady={isReady}
        setReady={setReady}
      />
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateRoute
          setCitys={setCitys}
          setSelectCitys={setSelectCitys}
          setChronologyCategory={setChronologyCategory}
          setSelectChronologyCategory={setSelectChronologyCategory}
          setShelterStatus={setShelterStatus}
          setSelectShelterStatus={setSelectShelterStatus}
          setRails={setRails}
          setSelectRails={setSelectRails}
          prefCode={prefCode}
          defaultCities={defaultCityArr}
        />
        }
        >
          {tabList.length > 0 && (
            <Route
              index
              element={
                <Navigate
                  to={`/${(() => {
                    const tabMapping = {
                      // SummaryForCity: 'summary_for_city',
                      // Summary: 'summary',
                      // UserRegisterForm: 'user_register_form',
                      // River: 'river',
                      // SoilRain: 'soil_rain',
                      Risk: 'risk',
                      AreaRisk: 'area_risk',
                      Chronology: 'chronology',
                      ShelterAnalysis: 'shelter_analysis',
                      RiskAnalysis: 'risk_analysis',
                    };
                    const originalTab = tabList[0];
                    return tabMapping[originalTab] || originalTab;
                  })()}`}
                  replace
                />
              }
            />
          )}
          <Route path="risk"
            element={
              BasePages(
                <Risk
                  citys={citys}
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  selectSubCity={selectSubCity}
                  setSelectSubCity={setSelectSubCity}
                  selectArea={selectArea}
                  setSelectArea={setSelectArea}
                  selectMsh={selectMsh}
                  setSelectMsh={setSelectMsh}
                  selectBsn={selectBsn}
                  setSelectBsn={setSelectBsn}
                  riskMapZoom={riskMapZoom}
                  setRiskMapZoom={setRiskMapZoom}
                  riskMapCenter={riskMapCenter}
                  setRiskMapCenter={setRiskMapCenter}
                  bsnMapZoom={bsnMapZoom}
                  setBsnMapZoom={setBsnMapZoom}
                  bsnMapCenter={bsnMapCenter}
                  setBsnMapCenter={setBsnMapCenter}
                  defaultUnit={defaultUnit}
                  h6Switch={h6Switch}
                  isReady={isReadyRisk}
                  setReady={setReadyRisk}
                />,
                LeftMenuPrefShinkoCitys(),
                LeftLegend(SOIL_RAIN_LEGEND_ITEMS),
                LeftReset(isReadyRisk, setReadyRisk),
                <></>,
                LeftSwitch6h15h(isReadyRisk, setReadyRisk),
                tabList,
                '/risk')
            }>
          </Route>
          {/* 市町村サマリ画面 */}

          {/* クロノロジー分析画面 */}
          <Route path="chronology"
            element={
              BasePages(
                <Chronology
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  selectSubCity={selectSubCity}
                  setSelectSubCity={setSelectSubCity}
                  selectMsh={selectMsh}
                  setSelectMsh={setSelectMsh}
                  riskMapZoom={riskMapZoom}
                  setRiskMapZoom={setRiskMapZoom}
                  riskMapCenter={riskMapCenter}
                  setRiskMapCenter={setRiskMapCenter}
                  defaultUnit={defaultUnit}
                  h6Switch={h6Switch}
                  isReady={isReadyChronology}
                  setReady={setReadyChronology}
                />,
                LeftMenuPrefShinkoCitys(),
                // LeftLegend(SOIL_RAIN_LEGEND_ITEMS),
                <></>,
                LeftReset(isReadyChronology, setReadyChronology),
                <></>,
                LeftSwitch6h15h(isReadyChronology, setReadyChronology),
                tabList,
                '/chronology')
            }>
          </Route>
          {/* {tabList.includes(PAGE_NAME.SUMMARY_FOR_CITY) && ( */}
          <Route path="summary_for_city"
            element={
              BasePages(
                <SummaryForCity
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  selectSubCity={selectSubCity}
                  setSelectSubCity={setSelectSubCity}
                  selectArea={selectArea}
                  setSelectArea={setSelectArea}
                  selectMsh={selectMsh}
                  setSelectMsh={setSelectMsh}
                  selectBsn={selectBsn}
                  setSelectBsn={setSelectBsn}
                  riskMapZoom={riskMapZoom}
                  setRiskMapZoom={setRiskMapZoom}
                  riskMapCenter={riskMapCenter}
                  setRiskMapCenter={setRiskMapCenter}
                  bsnMapZoom={bsnMapZoom}
                  setBsnMapZoom={setBsnMapZoom}
                  bsnMapCenter={bsnMapCenter}
                  setBsnMapCenter={setBsnMapCenter}
                  defaultUnit={defaultUnit}
                  h6Switch={h6Switch}
                  isReady={isReadySummaryCity}
                  setReady={setReadySummaryCity}
                />,
                LeftMenuPrefShinkoCitys(),
                LeftLegend(RISK_LEGEND_ITEMS),
                LeftReset(isReadySummaryCity, setReadySummaryCity),
                <></>,
                LeftSwitch6h15h(isReadySummaryCity, setReadySummaryCity),
                tabList,
                '/summary_for_city')
            }>
          </Route>
          {/* サマリー */}
          <Route path="summary"
            element={
              BasePages(
                <Summary
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  selectSubCity={selectSubCity}
                  setSelectSubCity={setSelectSubCity}
                  selectArea={selectArea}
                  setSelectArea={setSelectArea}
                  selectMsh={selectMsh}
                  setSelectMsh={setSelectMsh}
                  selectBsn={selectBsn}
                  setSelectBsn={setSelectBsn}
                  selectTelCode={selectTelCode}
                  setSelectTelCode={setSelectTelCode}
                  selectShelterCode={selectShelterCode}
                  setSelectShelterCode={setSelectShelterCode}
                  riskMapZoom={riskMapZoom}
                  setRiskMapZoom={setRiskMapZoom}
                  riskMapCenter={riskMapCenter}
                  setRiskMapCenter={setRiskMapCenter}
                  bsnMapZoom={bsnMapZoom}
                  setBsnMapZoom={setBsnMapZoom}
                  bsnMapCenter={bsnMapCenter}
                  setBsnMapCenter={setBsnMapCenter}
                  defaultUnit={defaultUnit}
                  h6Switch={h6Switch}
                  isReady={isReadySummary}
                  setReady={setReadySummary}
                />,
                LeftMenuPrefShinkoCitys(),
                LeftLegend(SOIL_RAIN_LEGEND_ITEMS),
                LeftReset(isReadySummary, setReadySummary),
                <></>,
                LeftSwitch6h15h(isReadySummary, setReadySummary),
                tabList,
                '/summary')
            }>
          </Route>
          {/* 土壌雨量指数
          <Route path="soil_rain"
            element={
              BasePages(
                <SoilRain
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  selectSubCity={selectSubCity}
                  setSelectSubCity={setSelectSubCity}
                  selectArea={selectArea}
                  setSelectArea={setSelectArea}
                  selectMsh={selectMsh}
                  setSelectMsh={setSelectMsh}
                  riskMapZoom={riskMapZoom}
                  setRiskMapZoom={setRiskMapZoom}
                  riskMapCenter={riskMapCenter}
                  setRiskMapCenter={setRiskMapCenter}
                  defaultUnit={defaultUnit}
                  h6Switch={h6Switch}
                  isReady={isReadySoilRain}
                  setReady={setReadySoilRain}
                />,
                LeftMenuPrefShinkoCitys(),
                LeftLegend(SOIL_RAIN_LEGEND_ITEMS),
                LeftReset(isReadySoilRain, setReadySoilRain),
                <></>,
                LeftSwitch6h15h(isReadySoilRain, setReadySoilRain),
                tabList,
                '/soil_rain')
            }>
          </Route> */}
          {/* 土砂災害発生リスク */}
          <Route path="area_risk"
            element={
              BasePages(
                <AreaRisk
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  selectSubCity={selectSubCity}
                  setSelectSubCity={setSelectSubCity}
                  selectArea={selectArea}
                  setSelectArea={setSelectArea}
                  selectMsh={selectMsh}
                  setSelectMsh={setSelectMsh}
                  selectBsn={selectBsn}
                  setSelectBsn={setSelectBsn}
                  riskMapZoom={riskMapZoom}
                  setRiskMapZoom={setRiskMapZoom}
                  riskMapCenter={riskMapCenter}
                  setRiskMapCenter={setRiskMapCenter}
                  bsnMapZoom={bsnMapZoom}
                  setBsnMapZoom={setBsnMapZoom}
                  bsnMapCenter={bsnMapCenter}
                  setBsnMapCenter={setBsnMapCenter}
                  defaultUnit={defaultUnit}
                  h6Switch={h6Switch}
                  isReady={isReadyAreaRisk}
                  setReady={setReadyAreaRisk}
                />,
                LeftMenuPrefShinkoCitys(),
                LeftLegend(RISK_LEGEND_ITEMS),
                LeftReset(isReadyAreaRisk, setReadyAreaRisk),
                <></>,
                LeftSwitch6h15h(isReadyAreaRisk, setReadyAreaRisk),
                tabList,
                '/area_risk')
            }>
          </Route>
          {/* <Route path="area_risk"
              element={
                BasePages(
                  <AreaRisk 
                    selectCitys={selectCitys} 
                    prefCode={prefCode}
                  />,
                  LeftMenuCitys(),
                  '/shizuokarea_riska')
              }>
            </Route> */}
          {/* <Route path="river"
              element={
                BasePages(
                  <River 
                    selectCitys={selectCitys}
                    prefCode={prefCode} 
                  />,
                  LeftMenuCitys(),
                  '/river')
              }>
            </Route> */}
          {/* 河川リスク */}
          <Route path="river"
            element={
              BasePages(
                <River
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  selectBsn={selectBsn}
                  setSelectBsn={setSelectBsn}
                  selectTelCode={selectTelCode}
                  setSelectTelCode={setSelectTelCode}
                  riskMapZoom={riskMapZoom}
                  setRiskMapZoom={setRiskMapZoom}
                  riskMapCenter={riskMapCenter}
                  setRiskMapCenter={setRiskMapCenter}
                  bsnMapZoom={bsnMapZoom}
                  setBsnMapZoom={setBsnMapZoom}
                  bsnMapCenter={bsnMapCenter}
                  setBsnMapCenter={setBsnMapCenter}
                  defaultUnit={defaultUnit}
                  h6Switch={h6Switch}
                  isReady={isReadyRiver}
                  setReady={setReadyRiver}
                />,
                LeftMenuPrefShinkoCitys(),
                // LeftLegend(RISK_LEGEND_ITEMS),
                <></>,
                LeftReset(isReadyRiver, setReadyRiver),
                <></>,
                LeftSwitch6h15h(isReadyRiver, setReadyRiver),
                tabList,
                '/river')
            }>
          </Route>
          {/* {tabList.includes(PAGE_NAME.RIVER) && (
              <Route path="/river"
                element={
                  <River
                    selectCitys={selectCitys}
                    prefCode={prefCode} 
                  />
                }>
              </Route>
            )} */}

          {/* <Route path="senior_risk"
              element={
                BasePages(
                  <SeniorRisk 
                    selectCitys={selectCitys}
                    prefCode={prefCode}
                  />,
                  LeftMenuCitys(),
                  '/senior_risk')
              }>
            </Route> */}
          {/* <Route path="road_risk"
              element={
                BasePages(
                  <RoadRisk 
                    selectCitys={selectCitys}
                    prefCode={prefCode} 
                  />,
                  LeftMenuCitys(),
                  '/road_risk')
              }>
            </Route> */}
          {/* <Route path="railway_risk"
              element={
                BasePages(
                  <RailwayRisk
                    selectCitys={selectCitys}
                    selectRails={selectRails} />,
                  LeftMenuRails(),
                  '/railway_risk'
                )
              }>
            </Route> */}
          {/* <Route path="chronology"
              element={
                BasePages(
                  <Chronology
                    setIsSearchDrawerOpen={setIsSearchChronologyDrawerOpen}
                    selectCitys={selectCitys}
                    selectShelterStatus={selectShelterStatus}
                    selectChronologyCategory={selectChronologyCategory}
                  />,
                  LeftMenuChronology(),
                  '/chronology')
              }>
            </Route> */}
          {/* <Route path="compatibility"
              element={
                RadioPages(
                  <Compatibility radioOption={radioOption} />,
                  radioOption, setRadioOption,
                  '/compatibility')
              }>
            </Route> */}

          {/* リスク分析画面 */}
          <Route path="/risk_analysis"
            element={
              BasePages(
                <RiskAnalysis
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  h6Switch={h6Switch}
                  isReady={isReadyRiskAnalysis}
                  setReady={setReadyRiskAnalysis}
                  riskAnalysisLayer={riskAnalysisLayer}
                  setRiskAnalysisLayer={setRiskAnalysisLayer}
                />,
                LeftMenuPrefShinkoCitys(),
                LeftLegend(getLegendItem(riskAnalysisLayer.category)),
                <></>,
                // LeftReset(isReadyRiskAnalysis, setReadyRiskAnalysis),
                LeftSwitchAnnounce(isReadyRiskAnalysis, setReadyRiskAnalysis),
                LeftSwitch6h15h(isReadyRiskAnalysis, setReadyRiskAnalysis),
                tabList,
                '/risk_analysis')
            }>
          </Route>

          {/* リスク分析画面 */}
          <Route path="/typhoon"
            element={
              BasePages(
                <Typhoon
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  h6Switch={h6Switch}
                  isReady={isReadyTyphoon}
                  setReady={setReadyTyphoon}
                />,
                LeftMenuPrefShinkoCitys(),
                LeftLegend(TYPHOON_LEGEND_ITEMS),
                <></>,
                <></>,
                <></>,
                // LeftReset(isReadyRiskAnalysis, setReadyRiskAnalysis),
                // LeftSwitch6h15h(isReadyTyphoon, setReadyTyphoon),
                tabList,
                '/typhoon')
            }>
          </Route>
          
          {/* 避難所分析 */}
          <Route path="shelter_analysis"
            element={
              BasePages(
                <ShelterAnalysis
                  selectCitys={selectCitys}
                  prefCode={prefCode}
                  selectSubCity={selectSubCity}
                  setSelectSubCity={setSelectSubCity}
                  selectMsh={selectMsh}
                  setSelectMsh={setSelectMsh}
                  selectShelterCode={selectShelterCode}
                  setSelectShelterCode={setSelectShelterCode}
                  riskMapZoom={riskMapZoom}
                  setRiskMapZoom={setRiskMapZoom}
                  riskMapCenter={riskMapCenter}
                  setRiskMapCenter={setRiskMapCenter}
                  defaultUnit={defaultUnit}
                  h6Switch={h6Switch}
                  isReady={isReadyShelterAnalysis}
                  setReady={setReadyShelterAnalysis}
                />,
                LeftMenuPrefShinkoCitys(),
                // LeftLegend(SOIL_RAIN_LEGEND_ITEMS),
                <></>,
                LeftReset(isReadyShelterAnalysis, setReadyShelterAnalysis),
                <></>,
                LeftSwitch6h15h(isReadyShelterAnalysis, setReadyShelterAnalysis),
                tabList,
                '/shelter_analysis')
            }>
          </Route>

          {/* ユーザー管理画面 */}
          {tabList.includes(PAGE_NAME.USER_REGISTER_FORM) && (
            <Route path="/user_register_form"
              element={
                <UserRegisterForm
                  isAdmin={true}
                />
              }>
            </Route>
          )}
        </Route>
        <Route path="signin" element={<SignIn />} />
        <Route path='logout' element={<Logout />} />
        <Route path='*' element={<></>} />
      </Routes>
    </BrowserRouter >
  )
}

export default Apps;